import _definePage_default_0 from '/codebuild/output/src2694990730/src/fibady-corp/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('/codebuild/output/src2694990730/src/fibady-corp/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  )
]
